/**
 * Vehicle types as the backend numbers them (VehicleType#getIndex). The order is part of the
 * Command Center payload the Tech App reads, so keep it.
 */
export const VEHICLE_TYPES: { value: number; label: string }[] = [
  { value: 1, label: 'Astro' },
  { value: 3, label: 'Cosmo' },
  { value: 0, label: 'Bike' },
  { value: 2, label: 'E-Bike' },
  { value: 4, label: 'Apollo' },
  { value: 5, label: 'Trike' },
];

export const ALL_VEHICLE_TYPES = VEHICLE_TYPES.map((t) => t.value);

/** Vehicle type name; "—" when absent, "#code" when unknown. */
export function vehicleTypeName(type: number | null | undefined): string {
  if (type == null) return '—';
  return VEHICLE_TYPES.find((t) => t.value === type)?.label ?? `#${type}`;
}

/**
 * A vehicle as people refer to it: its number. Vehicles without one (some D2C / private ones)
 * show their database id marked as such ("ID 1021354"), never a bare id that reads like a number.
 */
export function vehicleLabel(v: { vehicleNumber?: number | null; id?: number | null }): string {
  if (v.vehicleNumber != null) return String(v.vehicleNumber);
  return v.id != null ? `ID ${v.id}` : '—';
}
